import { z } from "zod";
import { ZDevice } from "./deviceSchema";
import { ZPolygon2D } from "./foundationSchema";
import { ZVec3M } from "./routingGraph.schema";
export const ZPipeElevationsM = z.object({
    xDirection: z.number(),
    yDirection: z.number(),
});
export const ZAutoPipeRoutingRoom = z.object({
    roomNumber: z.string().min(1),
    roomName: z.string().optional(),
    polygon: ZPolygon2D,
});
export const ZAutoPipeRoutingCostSettings = z.object({
    roomCrossingPenaltyM: z.number().default(3.0),
    corridorRoomFactor: z.number().default(0.1),
    blockedRoomFactor: z.number().default(100),
    verticalPenaltyFactor: z.number().default(3),
    perimeterPenaltyFactor: z.number().default(1),
});
export const ZAutoPipeRoutingInput = z.object({
    projectNo: z.number(),
    floorName: z.string().min(1),
    devicesToConnect: z.array(ZDevice),
    selectedRooms: z.array(ZAutoPipeRoutingRoom),
    pipeElevationsM: ZPipeElevationsM,
    connectionPoints: z.array(ZVec3M).min(1),
    roomCrossingPenaltyM: ZAutoPipeRoutingCostSettings.shape.roomCrossingPenaltyM,
    corridorRoomFactor: ZAutoPipeRoutingCostSettings.shape.corridorRoomFactor,
    blockedRoomFactor: ZAutoPipeRoutingCostSettings.shape.blockedRoomFactor,
    verticalPenaltyFactor: ZAutoPipeRoutingCostSettings.shape.verticalPenaltyFactor,
    perimeterPenaltyFactor: ZAutoPipeRoutingCostSettings.shape.perimeterPenaltyFactor,
});
